document.addEventListener('DOMContentLoaded', function() {
  const gallerySection = document.querySelector('[data-section-type="custom-gallery-section"]');

  if (!gallerySection) return;

  const sectionId = gallerySection.dataset.sectionId;
  const swiperContainer = gallerySection.querySelector('.swiper-gallery');

  if (!swiperContainer) return;

  const loopEnabled = gallerySection.dataset.loopEnabled === 'true';
  const autoplayEnabled = gallerySection.dataset.autoplayEnabled === 'true';
  const autoplayDelay = parseInt(gallerySection.dataset.autoplayDelay);
  const slidesPerViewMobile = parseFloat(gallerySection.dataset.slidesPerViewMobile);
  const slidesPerViewTablet = parseFloat(gallerySection.dataset.slidesPerViewTablet);
  const slidesPerViewDesktop = parseFloat(gallerySection.dataset.slidesPerViewDesktop);


  const swiperGallery = new Swiper(swiperContainer, {
    loop: loopEnabled,
    centeredSlides: true,
    speed: 500,
    ...(autoplayEnabled && {
      autoplay: {
        delay: autoplayDelay,
        disableOnInteraction: false,
      },
    }),
    preloadImages: false,
    lazy: {
      enabled: true,
      checkInView: true,
      loadPrevNext: true,
      loadPrevNextAmount: 2
    },
    slidesPerView: slidesPerViewMobile,
    spaceBetween: 0,
    breakpoints: {
      640: {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: 0
      },
      768: {
        slidesPerView: slidesPerViewTablet,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: slidesPerViewDesktop,
        spaceBetween: 0
      },
      1440: {
        slidesPerView: slidesPerViewDesktop,
        spaceBetween: 0
      },
      1920: {
        slidesPerView: slidesPerViewDesktop,
        spaceBetween: 0
      }
    }
  });

  function playVideo(slide) {
    const video = slide.querySelector('.swiper-video');
    const iframe = slide.querySelector('iframe.swiper-video');

    if (video && video.tagName === 'VIDEO') {
      video.muted = true;
      video.play().catch(e => console.log('HTML5 video autoplay blocked:', e));
    } else if (iframe) {
    }
  }

  function pauseVideo(slide) {
    const video = slide.querySelector('.swiper-video');
    const iframe = slide.querySelector('iframe.swiper-video');

    if (video && video.tagName === 'VIDEO') {
      video.pause();
      video.currentTime = 0;
    } else if (iframe) {
    }
  }

  swiperGallery.on('init', function() {
    setTimeout(() => {
      playVideo(this.slides[this.activeIndex]);
    }, 100);
  });

  swiperGallery.on('slideChangeTransitionEnd', function() {
    this.slides.forEach(slide => pauseVideo(slide));
    playVideo(this.slides[this.activeIndex]);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (swiperGallery.autoplay.running === false && autoplayEnabled) {
          swiperGallery.autoplay.start();
          playVideo(swiperGallery.slides[swiperGallery.activeIndex]);
        }
      } else {
        if (swiperGallery.autoplay.running === true) {
          swiperGallery.autoplay.stop();
        }
        swiperGallery.slides.forEach(slide => pauseVideo(slide));
      }
    });
  }, { threshold: 0.1 });

  observer.observe(gallerySection);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', function(event) {
      if (event.detail.sectionId === sectionId) {
        if (swiperGallery.autoplay.running === false && autoplayEnabled) {
          swiperGallery.autoplay.start();
        }
        playVideo(swiperGallery.slides[swiperGallery.activeIndex]);
      }
    });

    document.addEventListener('shopify:section:deselect', function(event) {
      if (event.detail.sectionId === sectionId) {
        if (swiperGallery.autoplay.running === true) {
          swiperGallery.autoplay.stop();
          swiperGallery.slides.forEach(slide => pauseVideo(slide));
        }
      }
    });
  }

});